import generateStore from './generateStore.js'
import { jwtDecode } from 'jwt-decode'
import { axios } from '../request'

export default (app) => {
  const store = generateStore('auth', app)

  store.state.isRefreshing = false
  store.state.accessTokenExpiresAt = 0

  const auth = localStorage.getItem('authentication')
  if (auth !== null) {
    store.state.jwt = jwtDecode(auth)
    store.state.accessTokenExpiresAt = localStorage.getItem('accessTokenExpiresAt')
  } else {
    store.state.jwt = {}
  }

  const refreshToken = localStorage.getItem('refreshToken')
  if (refreshToken !== null) {
    store.state.refreshToken = jwtDecode(refreshToken)
    store.state.refreshTokenString = refreshToken

    const refreshTokenExpiresAt = localStorage.getItem('refreshTokenExpiresAt')
    if (Math.floor(Date.now() / 1000) + 86400 > parseInt(refreshTokenExpiresAt, 10)) {
      //86400  is 24 hours
      localStorage.clear()
      if (location.pathname !== '/') {
        location.href = '/'
      }
    }
  } else {
    store.state.refreshToken = {}
  }

  store.mutations.login = function (state, payload) {
    localStorage.setItem('authentication', payload.access)
    localStorage.setItem('refreshToken', payload.refresh)
    state.authentication = payload.access
    state.jwt = jwtDecode(payload.access)

    //save accessToken
    state.jwt = jwtDecode(payload.access)
    const validityDuration = state.jwt.exp - state.jwt.iat
    const validUntil = Math.floor(Date.now() / 1000) + validityDuration
    state.accessTokenExpiresAt = validUntil
    localStorage.setItem('accessTokenExpiresAt', validUntil)

    //save refreshToken
    state.refreshTokenString = payload.refresh
    state.refreshToken = jwtDecode(payload.refresh)

    const refreshValidityDuration = state.refreshToken.exp - state.refreshToken.iat
    const refreshValidUntil = Math.floor(Date.now() / 1000) + refreshValidityDuration
    localStorage.setItem('refreshTokenExpiresAt', refreshValidUntil)

    state.errors = []
  }

  store.mutations.setRefreshing = function (state, v) {
    state.isRefreshing = v
  }

  store.actions.create = function (context) {
    context.commit('setErrors', { listName: 'default', key: 0, payload: {} })
    return new Promise((resolve, reject) => {
      const url = '/auth'
      axios
        .post(url, context.state.list.default.data[0])
        .then((res) => {
          context.commit('setLastStatus', res.status)
          if (res.status !== 204) {
            context.commit('login', res.data)
          }
          resolve()
        })
        .catch((err) => {
          context.commit('setLastStatus', err.response.status)
          if (typeof err.response.data !== 'undefined') {
            if (typeof err.response.data.errors !== 'undefined') {
              context.commit('setErrors', {
                listName: 'default',
                key: 0,
                payload: err.response.data.errors,
              })
            }
          }
          if (err.response.status === 403) {
            context.commit('setErrors', {
              listName: 'default',
              key: 0,
              payload: { global: 'wrongCredentials' },
            })
          }
          if (err.response.status === 404) {
            context.commit('setErrors', {
              listName: 'default',
              key: 0,
              payload: { global: 'accountNotFound' },
            })
          }
          reject()
        })
    })
  }
  store.actions.recoverUserPassword = function (context, email) {
    return new Promise((resolve) => {
      const body = {
        email: email,
        recover_password: true,
      }
      const url = '/auth'
      axios
        .post(url, body)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          console.log(err)
        })
    })
  }
  store.actions.setRefreshing = function (context, payload) {
    context.commit('setRefreshing', payload)
  }

  store.actions.setLoginData = function (context, payload) {
    context.commit('login', payload)
    context.dispatch('settings/checkIfRefreshIsNeeded', null, { root: true })
    context.dispatch('explainer/load', null, { root: true })
  }

  if (typeof store.getters === 'undefined') {
    store.getters = {}
  }

  store.getters.isLoggedin = function () {
    const auth = localStorage.getItem('authentication')
    if (auth !== null) {
      return true
    }
    return false
  }
  store.getters.role = function (state) {
    if (typeof state.jwt === 'undefined') {
      return undefined
    }
    if (typeof state.jwt.CustomUserInfo === 'undefined') {
      return undefined
    }

    return state.jwt.CustomUserInfo.Role
  }
  return store
}
